import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Button, Typography } from '@mui/material';
import CommonContainer from "../components/CommonContainer";
import { BASE_URL, LOGIN_EMAIL_VERIFY } from '../utills/ApplicationRouting';
import toast, { Toaster } from "react-hot-toast";
function Email() {
  const { token, contact, email } = useSelector((state) => state.qps);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleGetOtp = async () => {


    const otpPostData = { email: email };

    // Debugging logs
    console.log("Token:", token);
    console.log("Contact:", contact);
    console.log("Email:", email);
    console.log("Payload being sent:", otpPostData);

    try {
      const response = await axios.post(
        `${BASE_URL}${LOGIN_EMAIL_VERIFY}`,
        otpPostData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success(response.data);
        setIsLoading(false)
        // reset();
        setTimeout(() => {
          navigate("/login");
        }, 3000);
        console.log("OTP Sent");
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        setIsLoading(false)
        console.log(error.response.data.message);
        toast.error(error.response.data.message);
        console.log(error.response.data.message);
      }
    }
  };
  return (
    <>
      <Toaster />
      <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center">
          <Typography
  variant="h6"
  component="span"
  align="center"
  className="block w-full font-bold text-red-600"
>
  Email Not Verified
</Typography>

<br />
          <p className="text-gray-600 text-base mb-6">
  Please verify your registered email address to continue using your account.
</p>
         <Button
  variant="contained"
  fullWidth
  onClick={handleGetOtp}
  sx={{
    backgroundColor: "#153E75",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    py: 1,
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }}
>
  Resend Email
</Button>
<br />

<div className="text-gray-600 text-center" style={{ fontSize: "10px" }}>
  A verification email will be sent to your registered email address.
</div>
        </div>
      </div>
      </CommonContainer>
</div>
    </>

  )
}

export default Email
